import { action } from 'typesafe-actions';

import {
  CompanyReportTypes,
  CompanyReportInterface,
  ImportationsReportTypes,
  ImportationsReportInterface,
} from './types';

// List Company Report
export const listCompanyReportRequest = (payload: any) =>
  action(CompanyReportTypes.LIST_COMPANY_REPORT_REQUEST, payload);
export const listCompanyReportSuccess = (payload: {
  companyReportList: CompanyReportInterface[];
  totalCount: number;
}) => action(CompanyReportTypes.LIST_COMPANY_REPORT_SUCCESS, payload);
export const listCompanyReportFaliure = () =>
  action(CompanyReportTypes.LIST_COMPANY_REPORT_FAILURE);

// Importations Report
export const importaionsReportRequest = (payload: object) =>
  action(ImportationsReportTypes.IMPORTATIONS_REPORT_REQUEST, payload);
export const importaionsReportSuccess = (payload: {
  importationsReport: ImportationsReportInterface[];
  totalCount: number;
}) => action(ImportationsReportTypes.IMPORTATIONS_REPORT_SUCCESS, payload);
export const importaionsReportFaliure = () =>
  action(ImportationsReportTypes.IMPORTATIONS_REPORT_FAILURE);
